
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60","fill":"none","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M18.471 43.2c-1.68 2.95 0 4.94.79 5.63.79.69 3.64 2.1 5.68 1.46m-2.3-2.65c2.08-1.53 4.04-2.83 7.22-2.83m-16.65-17.54l9.95 10.72"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M50.291 23.26C49.191 19.27 42.391 8 29.861 8s-19.33 11.27-20.43 15.26c-1.1 3.99-3.87 9.6 3.51 15.47 7.38 5.87 7.65 6.14 10.13 9.49 2.47 3.35 4.71 3.89 6.8 3.89s4.32-.55 6.8-3.89c2.47-3.35 2.75-3.62 10.13-9.49 7.38-5.87 4.61-11.48 3.51-15.47h-.02z"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M41.261 43.2c1.68 2.95 0 4.94-.79 5.63-.79.69-3.64 2.1-5.68 1.46m2.29-2.65c-2.08-1.53-4.04-2.83-7.22-2.83m16.65-17.54l-9.94 10.72m-4.15-26.42c2.3.72 5.81 1.72 9.07 4.64m2.36 2.2c.19.21.72.76.89.98m-14.88-4.96V34"}})])
          )
        }
      }
    